import { create } from "zustand";
import { dataFetcher } from "../core/dataFetcher";
import { JWT } from "../api/types";

interface SDKConfigState {
  apiKey: string | null;
  baseUrl: string | null;
  apiPath: string | null;
  jwt: JWT | null;
  tenantId: string | null;
  isInitialized: boolean;

  setConfig: (config: {
    apiKey: string;
    baseUrl?: string;
    apiPath?: string;
    jwt?: JWT;
    tenantId?: string;
  }) => void;
  reset: () => void;
  clearJWT: () => void;
  setJWT: (jwt: JWT) => void;
}

export const useSDKConfigStore = create<SDKConfigState>((set, get) => ({
  apiKey: null,
  baseUrl: null,
  apiPath: null,
  tenantId: null,
  isInitialized: false,
  jwt: null,

  setConfig: (config) => {
    // Reset previous state
    get().reset();

    // Set new config
    set({
      apiKey: config.apiKey,
      baseUrl: config.baseUrl || "https://dev.console.fi",
      apiPath: config.apiPath || "/v1/vendor",
      tenantId: config.tenantId || null,
      jwt: config.jwt || null,
      isInitialized: true,
    });

    // Note: Data fetching will be triggered after authentication is complete
  },
  reset: () => {
    set({
      apiKey: null,
      baseUrl: null,
      apiPath: null,
      tenantId: null,
      isInitialized: false,
      jwt: null,
    });

    // Reset data stores
    dataFetcher.reset();
  },
  setJWT: (jwt: JWT) => {
    set({ jwt });
  },
  clearJWT: () => set({ jwt: null }),
}));
